import * as React from 'react';

import { NodeApi } from 'platejs';
import { SlateElement } from 'platejs/static';

export function VideoElementStatic(
  props
) {
  const { align = 'center', caption, url, width } = props.element;

  return (
    <SlateElement className="py-2.5" {...props}>
      <div style={{ textAlign: align }}>
        <figure
          className="group relative m-0 inline-block cursor-default"
          style={{ width }}>
          <div>
            <video
              className="w-full max-w-full rounded-sm object-cover px-0"
              src={url}
              controls />
          </div>
          {caption && <figcaption>{NodeApi.string(caption[0])}</figcaption>}
        </figure>
      </div>
      {props.children}
    </SlateElement>
  );
}
